import script from "./CreateBaseBusinessModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateBaseBusinessModal.vue?vue&type=script&lang=ts&setup=true"

import "./CreateBaseBusinessModal.vue?vue&type=style&index=0&id=89bfb956&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89bfb956"]])

export default __exports__